import {
  SET_MIN_LEAF_COUNT,
  SET_VERIFICATION_TIER,
  SET_KEYWORD_FILTER,
  CLEAR_FILTERS,
} from "../actions/types";

const initialState = {
  minLeafCount: null,      // null = no filter, 1-3 = minimum leaves
  verificationTier: null,  // null = all, 'verified' = green-solid only, 'guaranteed' = green-outline+solid
  keyword: "",             // empty string = no filter
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MIN_LEAF_COUNT:
      return {
        ...state,
        minLeafCount: payload,
      };
    case SET_VERIFICATION_TIER:
      return {
        ...state,
        verificationTier: payload,
      };
    case SET_KEYWORD_FILTER:
      return {
        ...state,
        keyword: payload,
      };
    case CLEAR_FILTERS:
      return initialState;
    default:
      return state;
  }
}
